import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface PortfolioPriceItem {
  ticker: string;
  currentPrice: number;
  dayChange: number;
  dayChangePercent: number;
  value: number;
}

export interface PortfolioPricesResponse {
  prices: PortfolioPriceItem[];
  totalValue: number;
  totalDayChange: number;
  totalDayChangePercent: number;
  lastUpdated: string;
  currency: string;
}

export function usePortfolioPrices() {
  return useQuery<PortfolioPricesResponse, Error>({
    queryKey: ["portfolioPrices"],
    queryFn: async () => {
      const { data } = await api.get<PortfolioPricesResponse>("/portfolio/current-prices");
      return data;
    },
    refetchInterval: 15 * 1000, // Refetch every 15 seconds
    refetchIntervalInBackground: true, // Continue fetching even when tab is not active
    staleTime: 10 * 1000, // Consider data stale after 10 seconds
    gcTime: 60 * 1000, // Keep in cache for 1 minute
  });
}